export const CONTAINER_WIDTH_MD = 752;

export const BORDER_RADIUS_MD = 24;
export const BORDER_RADIUS_SM = 16;